import React from "react";
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Switch from "@material-ui/core/Switch/Switch";



const AntSwitch = withStyles(theme => ({
  root: {
    width: 20,
    height: 10,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: 'grey',
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 6,
    height: 6,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

export default function InsideTextfieldSwitch(props) {

  return (
    <span>
      <Typography component="span" className="d-inline-flex">
        <Grid style={{display:'contents'}} container alignItems="center" >
          <Grid item>
            <Typography variant="caption">
              {props.switchLabelLeft}
            </Typography>
          </Grid>
          <Grid item style={{display:'flex',alignItems:'center',padding: '0 5px'}}>
            <AntSwitch
              checked={props.switchToggleChecked}
              onChange={props.switchToggleChange}
              value={props.switchToggleChecked}
              varient="secondary"

            />
          </Grid>
          <Grid item>
            <Typography variant="caption">
                {props.switchLabelRight}
            </Typography>
          </Grid>
        </Grid>
      </Typography>
    </span>

  );
}
